<template>
  <main>
    <div class="container-fluid">

      <ul class="nav nav-tabs  nav-tabs-custom   faq-tab-box" id="pills-tab" role="tablist">
        <!-- <li class="nav-item" role="presentation">
          <button class="nav-link active" id="willProcessViolation-tab" data-bs-toggle="pill" data-bs-target="#willProcessViolation">查詢</button>
        </li> -->
          <li class="nav-item" role="presentation">
          <button class="nav-link  active" id="moto-process-violation-tab" data-bs-toggle="pill" data-bs-target="#moto-process-violation"
            type="button" role="tab" aria-controls="moto-process-violation" aria-selected="false"> 機車闖入查詢 </button>
        </li>
        <li class="nav-item" role="presentation">
          <button class="nav-link " id="warning-close-violation-tab" data-bs-toggle="pill" data-bs-target="#warning-close-violation"
            type="button" role="tab" aria-controls="warning-close-violation" aria-selected="false"> 預警封閉查詢 </button>
        </li>


      </ul>

      <div class="tab-content p-3 shadow-sm" id="pills-tabContent" style="display: block;">
        <!-- <will-process-violation></will-process-violation> -->
        <moto-process-violation></moto-process-violation>
        <warning-close-violation></warning-close-violation>

      </div>
    </div>
  </main>
</template>

<script>
import willProcessViolation from './willProcessViolation.vue';
import motoProcessViolation from './motoProcessViolation.vue';
import warningCloseViolation from './warningCloseViolation.vue';




export default {
  components: { willProcessViolation, motoProcessViolation, warningCloseViolation },
  data() {
    return {
      
    };
  },
  computed: {
    
  },
  watch: {
    
  },
  methods: {
 
  },
  mounted() {

  },
};
</script>

<style>
</style>
